import { render, staticRenderFns } from "./TextAutoWidthIcon.vue?vue&type=template&id=a0184ad8&"
import script from "./TextAutoWidthIcon.vue?vue&type=script&lang=js&"
export * from "./TextAutoWidthIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports